import React from "react";
import { FormField } from "@avamae/formbuilder";
import FilePreviewer from "../FilePreviewer/FilePreviewer";
import {
  useFilePreviewerData,
  useFileUpload,
} from "./FilePreviewerFieldRenderer.hooks";

type FilePreviewerFieldRendererProps = {
  field: FormField<any>;
  enablePrint?: boolean;
  enableDownload?: boolean;
  enableFullscreen?: boolean;
  enableZoom?: boolean;
  enableUpload?: boolean;
};

const FilePreviewerFieldRenderer: React.FC<FilePreviewerFieldRendererProps> = ({
  field,
  enablePrint = true,
  enableDownload = true,
  enableFullscreen = true,
  enableZoom = true,
  enableUpload = false,
}) => {
  const { fileUrl, fileType, fileObject, acceptedFileTypes } = useFilePreviewerData(field);
  const { handleFileUpload } = useFileUpload(field, enableUpload);

  return (
    <FilePreviewer
      fileUrl={fileUrl}
      fileType={fileType}
      fileObject={fileObject}
      enablePrint={enablePrint}
      enableDownload={enableDownload}
      enableFullscreen={enableFullscreen}
      enableZoom={enableZoom}
      onFileUpload={handleFileUpload}
      acceptedFileTypes={acceptedFileTypes}
    />
  );
};

export default FilePreviewerFieldRenderer;
